<script>
import {
  logoutFromSSO as logoutFromSSOFunction,
  logoutFunction,
  logoutIfTokenInvalidFunction,
} from '@/composables/user';

export default {
  methods: {
    async logout({ reason, successUrl } = {}) {
      return logoutFunction(
        { reason, successUrl },
        this.$fischer,
        this.$cookies,
        () => (this.error = true),
      );
    },
    logoutFromSSO(redirectRelative) {
      return logoutFromSSOFunction(redirectRelative);
    },
    async logoutIfTokenInvalid(error) {
      return logoutIfTokenInvalidFunction(error, this.$fischer, (reason) => this.logout(reason));
    },
  },
};
</script>
